import { getModelVersionENVForProject } from '@/domain/impact/utils/get-model-version-for-project';
import { EnvQuestions } from '@/domain/impact-env/entities/question.entity';
import {
  selectCurrentProject,
  selectCurrentProjectMode,
} from '@/domain/project/project.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const getImpactEnvQuestions = createAppAsyncThunk(
  'impactEnv/getImpactEnvQuestions',
  async (
    _,
    { extra: { impactEnvGateway, snackbarGateway }, getState },
  ): Promise<EnvQuestions> => {
    try {
      const currentProject = selectCurrentProject(getState());
      const projectMode = selectCurrentProjectMode(getState());
      const modelVersion = getModelVersionENVForProject(
        projectMode,
        currentProject,
      );
      const answers =
        await impactEnvGateway.getImpactEnvQuestions(modelVersion);
      return answers;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactAnswers.Message.error'));
}
